import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9f22d88a")

_pushScopeId("data-v-9f22d88a")
const _hoisted_1 = { class: "dialog__content" }
const _hoisted_2 = { class: "dialog__list" }
const _hoisted_3 = { class: "dialog__item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon-home" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Accueil")
const _hoisted_6 = { class: "dialog__item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-team" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Équipes")
const _hoisted_9 = { class: "dialog__item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-calendar" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Calendrier")
const _hoisted_12 = { class: "dialog__item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-tree" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Séries")
const _hoisted_15 = { class: "dialog__item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-trophy" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Classement")
const _hoisted_18 = { class: "dialog__item" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Terrains")
const _hoisted_21 = {
  key: 0,
  class: "dialog__item"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "icon-rain" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Rainouts")
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "icon-info-circled" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Information ")
const _hoisted_26 = {
  key: 0,
  class: "icon-angle-down"
}
const _hoisted_27 = {
  key: 1,
  class: "icon-angle-right"
}
const _hoisted_28 = {
  key: 2,
  class: "subdialog__content"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "icon-text" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "dialog__item subdialog__item"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "icon-add" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Nouveau document ")
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "icon-archive" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Archives ")
const _hoisted_37 = {
  key: 0,
  class: "icon-angle-down"
}
const _hoisted_38 = {
  key: 1,
  class: "icon-angle-right"
}
const _hoisted_39 = {
  key: 4,
  class: "subdialog__content"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "icon-text" }, null, -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 5,
  class: "dialog__item"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "icon-partners" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Commanditaires")
const _hoisted_47 = { class: "dialog__item" }
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "icon-comment" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Contactez-nous")
const _hoisted_50 = {
  key: 6,
  class: "dialog__item"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "icon-help" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode("API Doc")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.mainMenuVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            onClose: _ctx.closeDialog,
            onClick: _ctx.closeDialog
          }, {
            body: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withId(() => [
                        _hoisted_4,
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_router_link, { to: "/teams" }, {
                      default: _withId(() => [
                        _hoisted_7,
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_router_link, { to: "/schedule" }, {
                      default: _withId(() => [
                        _hoisted_10,
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, { to: "/series" }, {
                      default: _withId(() => [
                        _hoisted_13,
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_router_link, { to: "/ranking" }, {
                      default: _withId(() => [
                        _hoisted_16,
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teamsIFavorite, (team, ix) => {
                    return (_openBlock(), _createBlock("div", {
                      key: ix,
                      class: "dialog__item"
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/teams/${team.name}`,
                        class: "team__link"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_TeamLabel, {
                            team: team,
                            favorite: true,
                            link: false
                          }, null, 8, ["team"])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128)),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teamsICaptain, (team, ix) => {
                    return (_openBlock(), _createBlock("div", {
                      key: ix,
                      class: "dialog__item"
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/teams/${team.name}`,
                        class: "team__link"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_TeamLabel, {
                            team: team,
                            captain: true,
                            link: false
                          }, null, 8, ["team"])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128)),
                  _createVNode("div", _hoisted_18, [
                    _createVNode(_component_router_link, { to: "/fields" }, {
                      default: _withId(() => [
                        _hoisted_19,
                        _hoisted_20
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.canViewRainouts)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode(_component_router_link, { to: "/timeslots" }, {
                          default: _withId(() => [
                            _hoisted_22,
                            _hoisted_23
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasInfo)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: "dialog__item subdialog--title",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleMainMenuInfo()), ["prevent","stop"]))
                      }, [
                        _hoisted_24,
                        _hoisted_25,
                        (_ctx.mainMenuInfoVisible)
                          ? (_openBlock(), _createBlock("i", _hoisted_26))
                          : (_openBlock(), _createBlock("i", _hoisted_27))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mainMenuInfoVisible)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        (_ctx.resourcesLoading)
                          ? (_openBlock(), _createBlock("div", _hoisted_29, [
                              _hoisted_30
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resources, (resource, ix) => {
                          return (_openBlock(), _createBlock("div", {
                            key: ix,
                            class: "dialog__item subdialog__item"
                          }, [
                            _createVNode(_component_router_link, {
                              to: `/resources/${resource}`
                            }, {
                              default: _withId(() => [
                                _hoisted_31,
                                _createTextVNode(" " + _toDisplayString(_ctx.prettyResource(resource)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128)),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createBlock("div", _hoisted_32, [
                              _createVNode(_component_router_link, {
                                to: `/resources/${_ctx.RESOURCE_TEMPLATE}`
                              }, {
                                default: _withId(() => [
                                  _hoisted_33,
                                  _hoisted_34
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasArchives)
                    ? (_openBlock(), _createBlock("div", {
                        key: 3,
                        class: "dialog__item subdialog--title",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleMainMenuArchive()), ["prevent","stop"]))
                      }, [
                        _hoisted_35,
                        _hoisted_36,
                        (_ctx.mainMenuArchiveVisible)
                          ? (_openBlock(), _createBlock("i", _hoisted_37))
                          : (_openBlock(), _createBlock("i", _hoisted_38))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mainMenuArchiveVisible)
                    ? (_openBlock(), _createBlock("div", _hoisted_39, [
                        (_ctx.archivesLoading)
                          ? (_openBlock(), _createBlock("div", _hoisted_40, [
                              _hoisted_41
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.archives, (archive, ix) => {
                          return (_openBlock(), _createBlock("div", {
                            key: ix,
                            class: "dialog__item subdialog__item"
                          }, [
                            _createVNode("a", null, [
                              (_ctx.isEditingArchive(archive.name))
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
                                  }, [
                                    _withDirectives(_createVNode("input", {
                                      class: "archive--input",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editArchiveName = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.editArchiveName]
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.viewArchive(archive.name))
                                  }, [
                                    _createVNode(_component_router_link, { to: "/schedule" }, {
                                      default: _withId(() => [
                                        _hoisted_42,
                                        _createTextVNode(" " + _toDisplayString(archive.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 8, ["onClick"]))
                            ]),
                            (_ctx.isAdmin)
                              ? (_openBlock(), _createBlock("span", _hoisted_43, [
                                  (_ctx.isEditingArchive(archive.name))
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        title: "Sauvegarder les modifications",
                                        class: "icon-upload",
                                        onClick: [
                                          ($event: any) => (_ctx.saveArchiveEdits(archive)),
                                          _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent","stop"]))
                                        ]
                                      }, null, 8, ["onClick"]))
                                    : (_openBlock(), _createBlock("i", {
                                        key: 1,
                                        title: "Modifier le nom de l'archive",
                                        class: "edit--logo icon-sketch",
                                        onClick: [
                                          ($event: any) => (_ctx.editArchive(archive)),
                                          _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent","stop"]))
                                        ]
                                      }, null, 8, ["onClick"]))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasSponsors || _ctx.canEditSponsors)
                    ? (_openBlock(), _createBlock("div", _hoisted_44, [
                        _createVNode(_component_router_link, { to: "/sponsors" }, {
                          default: _withId(() => [
                            _hoisted_45,
                            _hoisted_46
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_47, [
                    _createVNode(_component_router_link, { to: "/contact-us" }, {
                      default: _withId(() => [
                        _hoisted_48,
                        _hoisted_49
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.canViewDocumentation)
                    ? (_openBlock(), _createBlock("div", _hoisted_50, [
                        _createVNode(_component_router_link, { to: "/api" }, {
                          default: _withId(() => [
                            _hoisted_51,
                            _hoisted_52
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})